<template>
  <div class="container">
    <head-nav-bar title="住院信息" :fixed="true" />
    <div class="mt-header-nav">
      <cell-box class="grid1" style="padding: 0.3rem 0;" :column="2">
        <cell-item label="科室：" :value="info.departmentName" />
        <cell-item label="住院号：" :value="info.inPatientNo" />
      </cell-box>
      <div class="kong"></div>
      <cell-box style="padding: 0.3rem 0;" :column="2">
        <cell-item label="姓名：" :value="info.patientName" />
        <cell-item label="性别：" :value="info.patientSex" />
        <cell-item label="婚否：" :value="info.patientMarital" />
        <cell-item label="入院次数：">
          <span slot="value">
            <div>{{ info.inHospitalCount }}</div>
            <div class="text-less">{{ info.inhospitalRemark }}</div>
          </span>
        </cell-item>
        <cell-item label="入院日期：" :value="info.inDate" />
        <cell-item label="出院日期：" :value="info.outDate" />
        <cell-item label="住院天数：" :value="info.inDays" />
      </cell-box>
      <div class="kong"></div>
      <div class="box">
        <div class="label-title">入院诊断</div>
        <div class="text">{{ info.admittingDiagnosis }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Tab, Tabs, Button, Cell, Icon, Sticky } from "vant";
import { CellBox, CellItem } from "@/components/cell";
import { formatDate } from "@/utils/common";

export default {
  name: "Confirm",
  components: {
    CellBox,
    CellItem,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [Icon.name]: Icon,
    [Sticky.name]: Sticky,
  },
  computed: {},
  data() {
    return {
      queryParams: {},
      info: {},
      tabActive: "",
      totalDate: formatDate(),
      detaileDate: formatDate(),
    };
  },
  created() {
    this.queryParams = this.$route.query;
    this.getInfo();
  },
  methods: {
    getInfo() {
      this.$post("InHospital_Summary", {
        DiagnosisCardNo: this.queryParams.DiagnosisCardNo,
      }).then(res => {
        this.info = res.data;
      });
    },
    onSubmit() {},
    onDateChange(date) {
      console.log(date);
    },
  },
};
</script>

<style lang="less" scoped>
.money-box {
  padding: 0.3rem;
  margin-top: 0.5rem;
  .meony-symbol {
    font-size: 0.6rem;
    color: #999;
    line-height: 1.3rem;
  }
}
.money-select {
  .money-select-item div::after {
    border: 1px solid @main-color;
  }
}
.money {
  color: #333;
}

.mt-header-nav {
  /deep/.cell-item {
    .title {
      width: 70px;
      margin-right: 0;
    }
  }
  .grid1 {
    /deep/.cell-item {
      .title {
        width: 60px;
        margin-right: 0;
      }
    }
  }
}
</style>
